<div class="text-left">
    <div class="selectHalfday" style="padding-top: 10px;"><b>Half Date Dates</b></div>
    <div class="relative">
        <ng-select #halfdaySelect [items]="newlyAdded" bindLabel="text" bindValue="" [multiple]="true"
            [closeOnSelect]="false" [loading]="halfdayLoading" [typeahead]="halfdayInput$"
            typeToSearchText="Halfday Name" [virtualScroll]="true" [(ngModel)]="selectedHalfday"></ng-select>
        <i class="fa fa-search"></i>
    </div>
</div>